import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useUser } from "./Provider/UserProvider";
import { useNavigate } from "react-router-dom";
import { AccountMenu } from "./Component/AccountMenu";
import SendIcon from "@mui/icons-material/Send";
import { PAGE_PATH } from "./Common";

const theme = createTheme();

export function SignIn() {
  const { user, loginUser, resumeSession } = useUser();
  const navigate = useNavigate();
  const [loginMessage, setLoginMessage] = useState("");
  //const forgotPasswordURL = "/" + PAGE_PATH + "/ForgotPassword";

  const getHacaroCookieValues = () => {
    var hacaroCookies = {};

    var cookies = document.cookie;
    var cookiesArray = cookies.split(";");

    for (var c of cookiesArray) {
      var cArray = c.split("=");
      if (cArray[0].trim() == "hacaroUserId") {
        hacaroCookies.UserId = cArray[1].trim();
      } else if (cArray[0].trim() == "hacaroUserName") {
        hacaroCookies.UserName = cArray[1].trim();
      } else if (cArray[0].trim() == "hacaroWebToken") {
        hacaroCookies.WebToken = cArray[1].trim();
      }
    }

    return hacaroCookies;
  };

  useEffect(() => {
    if (user != undefined && user.id == "error") {
      setLoginMessage("ユーザー名かパスワードが間違っています");
    } else if (
      user != undefined &&
      user.id != undefined &&
      user.UserName != undefined &&
      user.WebToken != undefined
    ) {
      navigate("/");
      return;
    } else {
      setLoginMessage("");

      // cookieにUserName, WebTokenがあるか見る
      let hacaroCookies = getHacaroCookieValues();
      if (hacaroCookies && hacaroCookies.UserName && hacaroCookies.WebToken) {
        resumeSession(hacaroCookies.UserName, hacaroCookies.WebToken);
      }
    }
  }, [user]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    loginUser(data.get("UserName"), data.get("Password"));
  };

  return (
    <ThemeProvider theme={theme}>
      <AccountMenu />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#d33320" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            ハカロ-Hacaro- マイページ ログイン
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <Typography variant="body2" color="error">
              {/* アプリのユーザーIDとパスワードでログインしてください。*/}
            </Typography>
            {loginMessage == "" ? (
              <></>
            ) : (
              <Typography variant="body2" color={"error"}>
                {loginMessage}
              </Typography>
            )}
            <TextField
              margin="normal"
              required
              fullWidth
              id="UserName"
              label="ユーザー名"
              name="UserName"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="Password"
              label="パスワード"
              type="Password"
              id="Password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              endIcon={<SendIcon />}
              variant="contained"
              color="success"
              sx={{ mt: 1, mb: 2 }}
            >
              ログイン
            </Button>
          </Box>
        </Box>

        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item md={12}>
            <Link href={"/" + PAGE_PATH + "/ForgotPassword"} variant="p">
              パスワードを忘れましたか？
            </Link>
          </Grid>
          <Grid item md={12} sx={{ mt: 1 }}>
            <Typography variant="body2">
              新規登録をご希望の方はお問い合わせより、「マイページサービス申し込み」の旨をお伝え下さい。
            </Typography>
            <Button
              variant="outlined"
              size="small"
              sx={{ mt: 0.5 }}
              href="https://hacaro.jp/contact.html"
            >
              お問い合わせ
            </Button>
          </Grid>

          <Grid item md={12} mt={2}>
            <Typography variant="body2">
              当ページのご利用には「ハカロ-Hacaro-
              マイページサービス申し込み」が必要です。
            </Typography>
          </Grid>
          <Grid item md={12} bgcolor="#fcf8e3" p={1}>
            <Typography variant="body2">
              詳しくはこちらをご覧ください
            </Typography>
            <Link href="https://hacaro.jp/mypage-service.html" variant="body2">
              ハカロ-Hacaro- 公式サイト「マイページサービス」＞
            </Link>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  );
}
